module.exports = __webpack_public_path__ + "static/media/1.2f51d728.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/special/400/1.png
// module id = 1549
// module chunks = 0